import React from 'react';
import './styles.scss';

const Account = props => {
    
    if (!props.profile) return null;

    return (
        <div className="account">
            {props.profile &&
                <>
                    <h2 className="account__heading">Abonnemang</h2>
                    <div className="account__split">
                        <div className="account__split-col">
                            <table className="account__table">
                                <tbody>
                                    <tr>
                                        <th>Företag</th>
                                        <td>{props.profile.companyName}</td>
                                    </tr>
                                    {props.profile.onlineAccess &&
                                        <>
                                            <tr>
                                                <th>Abonnemang</th>
                                                <td><a className="account__link" target="_blank" rel="noreferrer" download href="https://dabas.blob.core.windows.net/delfinext-contracts/contracts/Abovillkor.pdf">{props.profile.onlineAccess.contract} abonnemangsvillkor</a></td>
                                            </tr>
                                            <tr>
                                                <th>Tillgång</th>
                                                <td>{props.profile.onlineAccess.access}</td>
                                            </tr>
                                            <tr>
                                                <th>Exportmöjlighet</th>
                                                <td>{props.profile.onlineAccess.export ? 'Ja' : 'Nej'}</td>
                                            </tr>
                                        </>
                                    }
                                    <tr>
                                        <th>Register access</th>
                                        <td>{props.profile.segmentRegister ? 'Ja' : 'Nej'}</td>
                                    </tr>
                                    <tr>
                                        <th>Statistik access</th>
                                        <td>{props.profile.segmentStatistics ? 'Ja' : 'Nej'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {props.profile.statisticsBranchAccess && props.profile.statisticsBranchAccess.length > 0 &&
                            <div className="account__split-col">
                                <table className="account__table-branch">
                                    <thead>
                                        <tr>
                                            <th>Gren</th>
                                            <th>Rapport</th>
                                            <th>Indata</th>
                                            <th>Exportera</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.profile.statisticsBranchAccess.map(branch => {
                                            return (
                                                <tr key={branch.branch.id}>
                                                    <td>{branch.branch.name}</td>
                                                    <td>{branch.reportReader && '✔️'}</td>
                                                    <td>{branch.reportWriter && '✔️'}</td>
                                                    <td>{branch.reportExport && '✔️'}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                </>         
            }
            
        </div>
    );
};

export default Account;